module.exports = __webpack_public_path__ + "static/media/time.8c9577a6.svg";